module.exports = __webpack_public_path__ + "src/images/measurements/neckLength.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/measurements/neckLength.jpg
// module id = 1154
// module chunks = 0